/**
 * Legacy /models route — redirects to /studio (Wave 3 b73).
 *
 * The Models rail item was dropped; the tenant-facing Models view is
 * now the first tab inside Studio. Sysadmin-only sub-pages
 * (Routing / Updates / Infrastructure / Registry / Health /
 * Distribution / Audit) live on the sysadmin side under
 * /sysadmin/models and /sysadmin/runtime.
 *
 * This catch-all redirect keeps existing bookmarks + agent-builder
 * links working; we redirect every /models* URL to /studio so users
 * don't land on a 404.
 */

import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/models')({
  beforeLoad: () => {
    throw redirect({ to: '/studio' });
  },
});
